import axios from "axios";
import { errorParser } from "../../helpers/errorHelper";
import { farmageo_api } from "../../config";

import { ALERT } from "./alertActions";
import store from "../store/index";

import { goToLogin } from "../../views/Pantalla/helper/funciones";

export const RESET_ERROR = () => {
  return (dispatch) => {
    dispatch({ type: "RESET_ERROR" });
  };
};

export const TRYREGISTER = (body) => {
  return (dispatch) => {
    axios
      .post(farmageo_api + "/farmacias/register-try", {
        email: body,
        destinatario: "soporte@farmageo.com.ar",
        version: "2",
      })
      .then((r) => alert(JSON.stringify(r.data)));
  };
};

export const LOGIN = (user, password, from) => {
  return (dispatch) => {
    axios
      .post(farmageo_api + "/users/loginwp", {
        username: user,
        password: password,
      })
      .then(function (response) {
        if (response.status === 500) {
          ALERT("Error", "Error de conexion con servidor", "error", "OK").then(
            () => {
              store.dispatch(LOGOUT());
              // window.location.replace(`${process.env.PUBLIC_URL}/#/login`);
              goToLogin();
              // window.location.reload();
            }
          );
        }
        if (parseInt(response.status) < 300) {
          dispatch({ type: "authenticated", payload: user });
          dispatch({ type: "LOGIN_OK", payload: response.data });
          dispatch({ type: "GET_USER_ROLES" });

          localStorage.setItem("login", JSON.stringify(response.data));
          localStorage.setItem("authenticated", JSON.stringify(true));
          localStorage.setItem("token", response.data.token);
          localStorage.setItem("loginId", user);
          localStorage.setItem("user", user);

          window.location.replace(
            from
              ? from.replace("/public/", "/pantalla/")
              : `${process.env.PUBLIC_URL}/#/pantalla/INICIO`
          );

          //  window.location.reload();
        }
      })
      .catch(function (error) {
        ALERT(
          "Error",
          error.response?.data?.error?.message ?? "Usuario y/o contraseña incorrectos",
          "error",
          "OK"
        ).then(() => {
          store.dispatch(LOGOUT());
        });
        dispatch(LOGOUT());
        dispatch({ type: "LOGIN_ERROR", error: errorParser(error) });
        return;
      });
  };
};

export const LOGOUT = () => {
  return (dispatch) => {
    const clearSession = () => {
      localStorage.removeItem("login");
      localStorage.removeItem("authenticated");
      localStorage.removeItem("token");
      localStorage.removeItem("refreshToken");
      localStorage.removeItem("loginId");
      localStorage.removeItem("user");
      localStorage.removeItem("pass");
      dispatch({ type: "LOGOUT" });
    };

    return axios
      .post(farmageo_api + "/logout")
      .catch(() => undefined)
      .then(clearSession);
  };
};

//TODO: AQUI SE DEBERIA CONSULTAR OTRA VEZ A LA API PARA PEDIS LOS ROLES: ARREGLAR ESTO PRONTO
export const GET_USER_ROLES = () => {
  return (dispatch) => {
    dispatch({ type: "GET_USER_ROLES" });
  };
};

export const IS_USER = () => {
  return (dispatch) => {
    dispatch({ type: "ISUSER" });
  };
};

export const GET_SESSION = () => {
  return async (dispatch) => {
    const user = localStorage.getItem("user");

    try {
      const response = await axios.post(farmageo_api + "/checkToken");
      if (response.data?.authenticated) {
        dispatch({
          type: "authenticated",
          payload: user,
        });
      }
    } catch (_error) {
      dispatch(LOGOUT());
    }
  };
};
